jQuery(document).ready(function ($) {
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 50) {
      $('body').addClass('float_active');
    } else {
      $('body').removeClass('float_active');
    }
  });

  $(document).on('click', '#menu_trigger', function (event) {
    event.preventDefault();

    if ($('body').hasClass('menu_open')) {
      $('body').removeClass('menu_open');
    } else {
      $('body').addClass('menu_open');
    }
  });

  //#mobile_menu_overlay
  $(document).on('click', '#mobile_menu_overlay', function (event) {
    event.preventDefault();
    $('body').removeClass('menu_open');
  });

  $('.smooth_scroll').click(function (event) {
    event.preventDefault();
    var margintop = $(this).data('mtop') ? $(this).data('mtop') : 100;

    if ($(this.hash).length > 0) {
      $('html,body').animate({ scrollTop: $(this.hash).offset().top - margintop }, 1200);
    }
  });

  //popup_form
  $(document).on('click', 'a[href^="#popup_"]', function (event) {
    event.preventDefault();
    var popup = $(this).attr('href').replace('#popup_', '');
    $('#' + popup).addClass('active');
  });

  $(document).on('click', '[data-close-popup]', function (event) {
    event.preventDefault();
    var popup = $(this).closest('.popup_form');
    $(popup).removeClass('active');
  });

  //testimonials_carousel
  const testimonials_carousel = new Swiper('.testimonials_carousel', {
    slidesPerView: 2.6,
    spaceBetween: 20,
    centeredSlides: true,
    initialSlide: 1,
    breakpoints: {
      0: {
        slidesPerView: 1.5,
      },
      992: {
        slidesPerView: 2.6,
        spaceBetween: 20,
        centeredSlides: true,
      },
    },
  });

  //products_carousel
  const products_carousel = new Swiper('.products_carousel', {
    spaceBetween: 15,
    slidesOffsetBefore: 70,
    navigation: {
      nextEl: '.carousel_nav_next',
      prevEl: '.carousel_nav_prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1.5,
      },
      992: {
        slidesPerView: 4.3,
      },
    },
  });

  //accordion_item_header
  $(document).on('click', '.accordion_item_header', function (event) {
    var item = $(this).closest('.accordion_item');
    var content = item.find('.accordion_item_content');

    if(item.hasClass('active')){

      item.removeClass('active');
      content.slideUp();
    }else{
      $('.accordion_item').removeClass('active');
      $('.accordion_item_content').slideUp();

      item.addClass('active');
      content.slideDown();
    }
  });

  // Shortcode system - Gallery Columns 3
  function processGalleryCols3Shortcode() {
    // Find all paragraphs containing the opening shortcode
    $('p:contains("[gallerycols3]")').each(function() {
      var startElement = $(this);
      var endElement = null;
      var elementsToWrap = [];
      
      // Find the closing shortcode
      var currentElement = startElement.next();
      while (currentElement.length > 0) {
        if (currentElement.is('p') && currentElement.text().includes('[/gallerycols3]')) {
          endElement = currentElement;
          break;
        }
        elementsToWrap.push(currentElement);
        currentElement = currentElement.next();
      }
      
      if (endElement) {
        // Create the row container
        var rowContainer = $('<div class="row row-cols-1 row-cols-lg-3 mb-4"></div>');
        
        // Wrap each element in a column div
        elementsToWrap.forEach(function(element) {
          var colDiv = $('<div class="col"></div>');
          colDiv.append($(element).contents()); // Move contents to preserve images
          rowContainer.append(colDiv);
        });
        
        // Replace the opening shortcode with the row container
        startElement.replaceWith(rowContainer);
        
        // Remove the elements that were wrapped
        elementsToWrap.forEach(function(element) {
          $(element).remove();
        });
        
        // Remove the closing shortcode
        endElement.remove();
      }
    });
  }

  // Process shortcodes on page load
  processGalleryCols3Shortcode();

  // Product variant price updater
  function initVariantPriceUpdater() {
    // Helper function to format money from cents (Shopify format)
    function formatMoneyFromCents(cents) {
      var format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
      if (typeof cents === 'string') {
        cents = cents.replace(/\./g, '');
      }
      var value = parseInt(cents || 0, 10);
      var dollars = (value / 100).toFixed(2);
      var dollarsNoDecimals = Math.floor(value / 100);
      var cents_part = (value % 100).toString().padStart(2, '0');
      
      // Handle different format patterns
      var formatted = format
        .replace(/\{\{amount\}\}/g, dollars)
        .replace(/\{\{amount_no_decimals\}\}/g, dollarsNoDecimals.toString())
        .replace(/\{\{amount_with_comma_separator\}\}/g, dollarsNoDecimals + ',' + cents_part)
        .replace(/\{\{amount_with_space_separator\}\}/g, dollarsNoDecimals + ' ' + cents_part);
      
      return formatted;
    }

    // Find all variant pickers on the page that haven't been initialized
    var variantPickers = document.querySelectorAll('.product-variant-picker[data-section-id]:not([data-price-updater-initialized])');
    
    variantPickers.forEach(function(variantPicker) {
      // Mark as initialized to avoid duplicate listeners
      variantPicker.setAttribute('data-price-updater-initialized', 'true');
      
      var sectionId = variantPicker.getAttribute('data-section-id');
      var priceContainer = document.getElementById('price-' + sectionId);
      
      if (!priceContainer) return;
      
      var variantSelects = variantPicker.querySelectorAll('.variant-option-select');
      var variantsJsonEl = variantPicker.querySelector('[data-variants-json]');
      
      if (!variantsJsonEl || variantSelects.length === 0) return;
      
      var variantsData;
      try {
        variantsData = JSON.parse(variantsJsonEl.textContent);
      } catch (e) {
        console.error('Error parsing variants JSON:', e);
        return;
      }
      
      function updatePrice() {
        var selectedOptions = {};
        variantSelects.forEach(function(select) {
          var optionPosition = parseInt(select.dataset.optionPosition, 10);
          selectedOptions[optionPosition] = select.value;
        });
        
        // Find matching variant
        var matchingVariant = variantsData.find(function(variant) {
          var matches = true;
          for (var i = 1; i <= 3; i++) {
            var optionKey = 'option' + i;
            if (selectedOptions[i]) {
              if (variant[optionKey] !== selectedOptions[i]) {
                matches = false;
                break;
              }
            } else if (variant[optionKey]) {
              matches = false;
              break;
            }
          }
          return matches;
        });
        
        if (matchingVariant && priceContainer) {
          // Update price
          var price = matchingVariant.price;
          var compareAtPrice = matchingVariant.compare_at_price;
          var formattedPrice = formatMoneyFromCents(price);
          var formattedCompareAtPrice = compareAtPrice ? formatMoneyFromCents(compareAtPrice) : null;
          
          // Update price display
          var priceRegular = priceContainer.querySelector('.price__regular .price-item--regular');
          var priceSale = priceContainer.querySelector('.price__sale .price-item--sale');
          var compareAtPriceEl = priceContainer.querySelector('.price__sale .price-item--regular s');
          
          if (compareAtPrice && compareAtPrice > price) {
            // Show sale price
            priceContainer.classList.add('price--on-sale');
            priceContainer.classList.remove('price--sold-out');
            if (priceSale) priceSale.textContent = formattedPrice;
            if (compareAtPriceEl) compareAtPriceEl.textContent = formattedCompareAtPrice;
          } else {
            // Show regular price
            priceContainer.classList.remove('price--on-sale');
            if (priceRegular) priceRegular.textContent = formattedPrice;
          }
          
          // Update availability
          if (!matchingVariant.available) {
            priceContainer.classList.add('price--sold-out');
          } else {
            priceContainer.classList.remove('price--sold-out');
          }
        }
      }
      
      // Listen for variant changes
      variantSelects.forEach(function(select) {
        select.addEventListener('change', updatePrice);
      });
      
      // Initialize price on load
      updatePrice();
    });
  }

  // Initialize popup for custom stickers upload previews (Magnific Popup)
  function initCustomStickerUploadPopup() {
    // Ensure Magnific Popup is available
    if (typeof $.fn.magnificPopup === 'undefined') {
      return;
    }

    $('.upload_input_wrapper').each(function () {
      var $wrapper = $(this);

      $wrapper.magnificPopup({
        delegate: '.fileuploader-item-image img',
        type: 'image',
        closeOnContentClick: true,
        mainClass: 'mfp-fade',
        image: {
          verticalFit: true
        },
        callbacks: {
          elementParse: function (item) {
            var $img = $(item.el);
            var srcAttr = $img.attr('src') || null;

            // Ensure Magnific Popup uses the same src as the thumbnail
            if (srcAttr) {
              item.src = srcAttr;
            }
          }
        }
      });
    });
  }

  // Initialize popup for cart drawer images (Magnific Popup)
  function initCartDrawerImagePopup() {
    // Use delegated click so it works even if cart drawer content is loaded dynamically
    $(document).on('click', '#cart-drawer a.cart_item_image', function (event) {
      // If Magnific Popup is not available, let the default link behavior happen
      if (typeof $.fn.magnificPopup === 'undefined') {
        return;
      }

      event.preventDefault();

      var $link = $(this);
      var href = $link.attr('href') || '';

      if (!href) {
        return;
      }

      $.magnificPopup.open({
        items: {
          src: href
        },
        type: 'image',
        closeOnContentClick: true,
        mainClass: 'mfp-fade',
        image: {
          verticalFit: true
        }
      });
    });
  }

  // Initialize variant price updater on page load
  initVariantPriceUpdater();
  
  // Also initialize when DOM is updated (for dynamic content and theme editor)
  if (typeof document.addEventListener !== 'undefined') {
    document.addEventListener('shopify:section:load', function() {
      // Reset initialization flags when section reloads
      var variantPickers = document.querySelectorAll('.product-variant-picker[data-section-id][data-price-updater-initialized]');
      variantPickers.forEach(function(picker) {
        picker.removeAttribute('data-price-updater-initialized');
      });
      initVariantPriceUpdater();
    });
  }

  // Initialize popup behavior for custom stickers upload
  initCustomStickerUploadPopup();
  // Initialize popup behavior for cart drawer images
  initCartDrawerImagePopup();
});
